import { useIntl } from 'react-intl';
import { MiniSelectionView } from './MiniSelectionView';
import { extractLastSegment } from './requestQuote.utils';
import { SuccessCheck } from './SuccessCheck';
import { Text } from '../../../../../../UILibrary';
import { definedTranslation } from '../../i18n';

type RequestQuoteSuccessContentProps = {
  selectedVariantImg: string | null;
  onInboxClick?: () => void;
};

export function RequestQuoteSuccessContent({
  selectedVariantImg,
  onInboxClick,
}: RequestQuoteSuccessContentProps) {
  const intl = useIntl();

  const onGoToInboxClicked = () => {
    // Open the inbox
    localStorage.setItem('inboxOpenLastThread', 'true');
    window.location.href = '/inbox';
    onInboxClick?.();
  };

  const firstGalleryImage = window.galleryImages?.[0]?.url;
  const productId = window.productAttributeJson?.product_id?.value ?? '';
  const initialImage =
    window.productConfigurableJson?.images?.[productId]?.[0]?.url;

  return (
    <div className="pt-6 flex flex-col gap-8">
      <div className="py-4 border-t border-b border-[#F2F2F2]">
        <MiniSelectionView
          category={
            window.productAttributeJson?.taxonomy_us?.value
              ? extractLastSegment(
                  window.productAttributeJson?.taxonomy_us?.value,
                )
              : undefined
          }
          name={window.productAttributeJson?.name?.value}
          manufacturer={window.productAttributeJson?.manufacturer?.value}
          imgSrc={
            window.productConfigurableJson === undefined
              ? firstGalleryImage
              : selectedVariantImg ?? initialImage ?? firstGalleryImage
          }
        />
      </div>

      <div className="flex flex-col items-center gap-3">
        <SuccessCheck />
        <Text variant="H1" className="pt-1">
          {intl?.formatMessage(definedTranslation.requestQuote.successLabel)}
        </Text>
        <Text>
          {intl?.formatMessage(
            definedTranslation.requestQuote.successSubtextLabel,
          )}
        </Text>
      </div>

      <button
        onClick={onGoToInboxClicked}
        className="w-full rounded-full outline-none flex items-center justify-center"
        style={{
          height: 48,
          backgroundColor: '#4D4E58',
          color: '#FFF',
        }}
      >
        {intl?.formatMessage(definedTranslation.requestQuote.goToInboxBtn)}
      </button>
    </div>
  );
}
